import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 3324BD04-3F49-4759-9C4E-8C94F513F977
 * name tally-mark-2
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tally-mark-2.svg
 * tags
 * - Math 
 */
export const TallyMark2Icon = createSvgIcon(<><path d="M11 19H9V5H11V19M15 5H13V19H15V5Z" /></>, 'TallyMark2Icon');
export default TallyMark2Icon